// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import LeafletMapController from "./leaflet_map_controller"
import TerritoryMapController from "./territory_map_controller"

application.register("leaflet-map", LeafletMapController)
application.register("territory-map", TerritoryMapController)
